import { render, staticRenderFns } from "./BodyScars.vue?vue&type=template&id=b97e06dc&scoped=true&"
import script from "./BodyScars.vue?vue&type=script&lang=ts&"
export * from "./BodyScars.vue?vue&type=script&lang=ts&"
import style0 from "./BodyScars.vue?vue&type=style&index=0&id=b97e06dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97e06dc",
  null
  
)

export default component.exports